import React, { useState, useEffect } from 'react';
import './SocialProof.css';

const SocialProof: React.FC = () => {
  const [backgroundImage, setBackgroundImage] = useState<string>('/assets/social-proof/kitchen.jpg');

  useEffect(() => {
    // Check if the background image loads successfully
    const img = new Image();
    img.src = '/assets/social-proof/kitchen.jpg';
    img.onerror = () => {
      // If image fails to load, use fallback
      setBackgroundImage('https://api.builder.io/api/v1/image/assets/TEMP/46b7939e5bebf1b51c9bf6b1599f55e6c8e8dbea?width=2880');
    };
    img.onload = () => {
      // Image loaded successfully
      setBackgroundImage('/assets/social-proof/kitchen.jpg');
    };
  }, []);

  return (
    <section 
      className="social-proof-section" 
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: 'lightgray'
      }}
    >
      <div className="social-proof-badge">
        <p className="social-proof-text">
          Join <strong>hundreds of satisfied homeowners</strong> who have trusted us to secure their financial future. Rated <strong>4.9/5</strong> for delivering personalized mortgage solutions, from buying a home to refinancing and reverse mortgages.
        </p>
      </div>
    </section>
  );
};

export default SocialProof;
